var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markups-insurance"},[_c('label',{staticClass:"markups-insurance__title"},[_vm._v("Apply markup to insurance value")]),_c('b-form-checkbox',{staticClass:"markups-insurance__checkbox",model:{value:(_vm.applyMarkupsInsurance),callback:function ($$v) {_vm.applyMarkupsInsurance=$$v},expression:"applyMarkupsInsurance"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }